module.exports = __webpack_public_path__ + "img/logo.62d2fa4f.png";